export default __webpack_public_path__ + "static/media/promo_00.6e8f56cb.jpg";